import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "We listen first",
    body: "Every family, every business is different. Before any policy or loan is mentioned, we understand your dependents, your goals and your worries — in plain language, never jargon.",
  },
  {
    n: "02",
    title: "We compare, you choose",
    body: "Through our association with leading insurers, banks and NBFCs, we line up the strongest options side by side — cover, premium, claim record, rate — and you decide with full clarity.",
  },
  {
    n: "03",
    title: "We stand by you at claim time",
    body: "A policy is only a promise until the day it's tested. From hospital admissions to loan disbursals, we chase the paperwork so you don't have to.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="py-24 md:py-32 bg-forest-deep text-white relative overflow-hidden" data-testid="manifesto-section">
    <div className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-forest-soft/40 blur-3xl" />
    <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
      <Reveal>
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-mint-soft">Our promise</p>
        <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight max-w-2xl text-balance">
          Advice you'd give your own family
        </h2>
      </Reveal>

      <div className="mt-20 flex flex-col gap-20 md:gap-28">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08}>
            <div className="grid md:grid-cols-12 gap-6 md:gap-10 items-start border-t border-white/10 pt-12">
              <span className="md:col-span-3 font-serif text-7xl md:text-8xl text-mint/25 leading-none select-none">{c.n}</span>
              <div className="md:col-span-9">
                <h3 className="font-serif text-2xl sm:text-3xl text-mint-pale">{c.title}</h3>
                <p className="mt-4 text-base sm:text-lg text-white/70 leading-relaxed max-w-2xl">{c.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
